// @mui icons
import TwitterIcon from "@mui/icons-material/Twitter";
import GitHubIcon from "@mui/icons-material/GitHub";

// Material Kit 2 PRO React components
import MKTypography from "components/MKTypography";

// Images
import foxlogo from "assets/images/foxlogo-512px.png";

const date = new Date().getFullYear();

export default {
    brand: {
        name: "The Silver Fox",
        image: foxlogo,
        route: "/",
    },
    socials: [
        {
            icon: <TwitterIcon />,
            link: "https://twitter.com/ErialosOfAstora",
            target: "_blank",
        },
        {
            icon: <GitHubIcon />,
            link: "https://github.com/effofxprime",
            target: "_blank",
        },
    ],
    menus: [
        {
            items: [
                {
                    name: "Foxy Dashboard",
                    href: "https://dashboard.thesilverfox.pro",
                    target: "_blank",
                },
            ],
        },
        {
            items: [
                {
                    name: "Discord Server",
                    href: "https://discord.gg/ZSwMGQNhhz",
                    target: "_blank",
                },
            ],
        },
    ],
    copyright: (
        <MKTypography variant="button" fontWeight="regular">
            All rights reserved. Copyright &copy; {date} Material Kit by{" "}
            <MKTypography
                component="a"
                href="https://thesilverfox.pro"
                target="_blank"
                rel="noreferrer"
                variant="button"
                fontWeight="regular"
            >
                The Silver Fox
            </MKTypography>
            .
        </MKTypography>
    ),
};
